import {
  ballArr,
  count,
  singleDouble,
  singleDoubleCnname,
  smallBig,
  continuity,
  continuityCnname,
  smallBigCnname,
  dragonTiger,
  fishCnname
} from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

// let treeChildren = data => {
//   var arr = [];
//   var shape = ['大', '小', '单', '双'];
//   var str = ['big', 'small', 'single', 'double'];
//   if (data) {
//     for (let i = 0; i < shape.length; i++) {
//       var obj = {};
//       obj.title = `${shape[i]}`;
//       obj.align = 'center';
//       // obj.width = '37';
//       obj.className = `join_table_children`;
//       obj.render = (h, row) => {
//         return <span>2</span>;
//         // if (i < 2) {
//         //   if (row.row.ballObj.ballBigSmall[str[i]] == 0) {
//         //     // return <span  class="table_join_red">{shape[i]}</span>;
//         //     return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
//         //   } else {
//         //     return <span class="table_join">{row.row.ballObj.ballBigSmall[str[i]]}</span>;
//         //   }
//         // } else if (1 < i && i < 4) {
//         //   if (row.row.ballObj.ballSingleDouble[str[i]] == 0) {
//         //     return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
//         //   } else {
//         //     return <span class="table_join">{row.row.ballObj.ballSingleDouble[str[i]]}</span>;
//         //   }
//         // }
//       };
//       arr.push(obj);
//     }
//     return arr;
//   }
// };

const ssc = data => {
  let list = Vue => {
    let arr = [
      {
        title: '日期',
        align: 'center',
        key: 'date',
        className: `table_issueId`,
        width: 150
        // render: (h, { row }) => <span class="issue_result">4234234234</span>
      }
    ];
    for (let i = 1; i < 7; i++) {
      let obj = {};
      obj.title = i;
      obj.align = 'center';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.render = (h, { row }) => {
        return <span class="">{row.num_history_json[i]}</span>;
      };
      // obj.render = (h, { row }) => <span class="issue_result">3</span>;
      arr.push(obj);
    }
    var a = ['大', '小'];
    var keys = ['big', 'small'];
    for (let i = 0; i < a.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = e;
      obj.align = 'center';
      obj.className = `table_info_column_${i}`;
      obj.render = (h, { row }) => {
        return <span class="">{row.num_history_json[keys[i]]}</span>;
      };
      // obj.render = (h, { row }) => <span class="issue_result">3</span>;
      arr.push(obj);
    }
    let arr1 = [
      {
        title: '时间',
        align: 'center',
        key: 'date',
        className: `table_issueId`,
        width: 150,
        render: (h, { row }) => {
          return <span>{dayjs(row.date).format('MM-DD')}</span>;
        }
        // render: (h, { row }) => <span class="issue_result">4234234234</span>
      }
    ];
    for (let i = 1; i < 7; i++) {
      let obj = {};
      obj.title = i;
      obj.align = 'center';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.render = (h, { row }) => {
        return <span class="">{row.num_history_json[i]}</span>;
      };
      // obj.render = (h, { row }) => <span class="issue_result">3</span>;
      arr1.push(obj);
    }
    var a = ['大', '小'];
    var keys = ['big', 'small'];
    for (let i = 0; i < a.length; i++) {
      let obj = {};
      let e = a[i];
      obj.title = e;
      obj.align = 'center';
      obj.className = `table_info_column_${i}`;
      obj.render = (h, { row }) => {
        return <span class="">{row.num_history_json[keys[i]]}</span>;
      };
      // obj.render = (h, { row }) => <span class="issue_result">3</span>;
      arr1.push(obj);
    }
    if (Vue.showMobile) {
      return arr1;
    } else {
      return arr;
    }
  };

  return { list };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Lishihaomatongji/columns/ks.js